import React from 'react';
import Tooltip from './Tooltip';

export default ({ statusDetail }) => (
  <address className="nbn-infobox__column__address nbn-font--normal">
    <div className="tablecell"><i className="icon-location icon-size-large nbn-text-light-blue"/></div>
    <div className="tablecell text-xx-small line-height-medium has-margin-bottom-xsmall fin-text-grey">
      <span className="show">{ statusDetail.full_address }</span>
    </div>
    { (statusDetail.csa_id || statusDetail.sa_id || statusDetail.region_id || statusDetail.fda_id || statusDetail.location_id || statusDetail.service_class)
      && (
        <div className="tablecell">
          <Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue has-margin-left-xxsmall" position="top">
            <p className="weight-semi-bold text-xx-large">Technical Details</p>
            { statusDetail.poi_id
              && (<p><span className="weight-semi-bold">POI ID:</span> <span className="nowrap-md">{ statusDetail.poi_id }</span></p>)
            }
            { statusDetail.csa_id
              && (<p><span className="weight-semi-bold">CSA ID:</span> <span className="nowrap-md">{ statusDetail.csa_id }</span></p>)
            }
            { statusDetail.sa_id
              && (<p className="nowrap-md"><span className="weight-semi-bold">SA ID:</span> <span className="nowrap-md">{ statusDetail.sa_id }</span></p>)
            }
            { statusDetail.sam_id
            && (<p className="nowrap-md"><span className="weight-semi-bold">SAM ID:</span> <span className="nowrap-md">{ statusDetail.sam_id }</span></p>)
            }
            { statusDetail.region_id
              && (<p className="nowrap-md"><span className="weight-semi-bold">Region ID:</span> <span className="nowrap-md">{ statusDetail.region_id }</span></p>)
            }
            { statusDetail.fda_id
              && (<p className="nowrap-md"><span className="weight-semi-bold">ADA:</span> <span className="nowrap-md">{ statusDetail.fda_id }</span></p>)
            }
            { statusDetail.xda_id
              && (<p className="nowrap-md"><span className="weight-semi-bold">XDA:</span> <span className="nowrap-md">{ statusDetail.xda_id }</span></p>)
            }
            { statusDetail.location_id
              && <p className="nowrap-md"><span className="weight-semi-bold">Location ID:</span> <span className="nowrap-md">{ statusDetail.location_id }</span></p>
            }
            { statusDetail.service_class
              && (<p className="nowrap-md"><span className="weight-semi-bold">Service Class:</span> <span className="nowrap-md">{ statusDetail.service_class }</span></p>)
            }
          </Tooltip>
        </div>
      )
    }
  </address>
);